'use client';

import StoriesPageCards from '@components/templates/stories/StoriesPageCards';

/**
 * Empty-state landing for the candidate coaching (bestie-chat) view.
 * Shows interview stories until the user starts a Bestie chat from the CandidatePromptBar.
 */
export const CoachingLanding = ({
  locale,
  initialStoriesData,
}: {
  locale: Locale;
  initialStoriesData?: ApiSchema<'ResumeStoriesResult'>;
}) => {
  return (
    <section className="grow bg-surface-100">
      <StoriesPageCards
        locale={locale}
        initialData={initialStoriesData}
        storyRoute="/mc/bestie-chat"
        syncUrl={false}
      />
    </section>
  );
};
